import { combineReducers, compose, createSelector } from '@reduxjs/toolkit';

import slice from './subcatalogs.slice';
import subcatalogsAdapter from './subcatalogs.adapter';

import type { SubcatalogAPIData } from 'types/catalog_types';
import type { Dictionary } from 'types/common_types';

/** Represents the slice as it exists in the final store's reducer */
const combined = combineReducers({ [slice.name]: slice.reducer });
type GlobalState = ReturnType<typeof combined>;

/** Get the local state for the current domain */
const localState = (state: GlobalState) => state[slice.name];
type LocalState = ReturnType<typeof localState>;

// Localized Selectors
const defaultSelectors = subcatalogsAdapter.getSelectors();

export const selectAllSubcatalogsByCatalogId = createSelector(
  [defaultSelectors.selectAll],
  (subcatalogs) =>
    subcatalogs.reduce((acc: Dictionary<SubcatalogAPIData[]>, s: SubcatalogAPIData) => {
      const arr = acc[s.parentId];

      if (arr) {
        acc[s.parentId] = arr.concat([s]);
      } else {
        acc[s.parentId] = [s];
      }

      return acc;
    }, {})
);

export const selectAllSubcatalogIdsBySlug = createSelector(
  [defaultSelectors.selectAll],
  (allSubcatalogs) =>
    allSubcatalogs.reduce((acc: Record<string, number>, subcatalog) => {
      acc[subcatalog.slug] = subcatalog.id;
      return acc;
    }, {})
);

/**
 * Globalized selectors that know how to select data from the RootState
 */
export default {
  ...subcatalogsAdapter.getSelectors(localState),
  idsBySlug: compose(selectAllSubcatalogIdsBySlug, localState),
  allByCatalogId: compose(selectAllSubcatalogsByCatalogId, localState),
};
